document.addEventListener('DOMContentLoaded', () => {
  // Desktop callout hover logic
  const visualContainer = document.querySelector('.dashboard-visual');
  if (visualContainer) {
    const callouts = visualContainer.querySelectorAll('.dashboard-callout');
    const annotations = visualContainer.querySelectorAll(
      '.dashboard-annotation-text'
    );

    if (callouts.length > 0 && annotations.length > 0) {
      const setActive = (index) => {
        callouts.forEach((c) => c.classList.remove('active'));
        annotations.forEach((a) => a.classList.remove('active'));

        if (callouts[index]) {
          callouts[index].classList.add('active');
        }
        if (annotations[index]) {
          annotations[index].classList.add('active');
        }
      };

      setActive(0);

      callouts.forEach((callout, index) => {
        callout.addEventListener('mouseenter', () => {
          setActive(index);
        });
      });
    }
  }

  // Mobile dot/content logic (new)
  function setupMobileDots() {
    if (window.innerWidth > 989) return;
    const dots = document.querySelectorAll('.mobile-dot');
    const contents = document.querySelectorAll('.dashoboard-mobile-text');
    if (!dots.length || !contents.length) return;

    function setActive(index) {
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.classList.add('active');
          dot.style.opacity = '1';
        } else {
          dot.classList.remove('active');
          dot.style.opacity = '0.4';
        }
      });
      contents.forEach((content, i) => {
        content.style.display = i === index ? 'block' : 'none';
      });
    }

    // Default: first dot/content active
    setActive(0);

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => setActive(i));
    });
  }
  setupMobileDots();
  window.addEventListener('resize', () => {
    // Re-setup on resize to handle orientation/device changes
    setupMobileDots();
  });
});
